import React, { useContext, useState } from 'react';
import { LoadingContext } from '@context/LoadingProvider';
import { Form, Formik } from 'formik';
import TextInput from '@atoms/TextInput';
import { ButtonPrimaryLarge } from '@styled';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { requestPasswordReset } from '@general/api/memberAPI';
import useStytchQueryString from '../../../../hooks/useStytchQueryString';

const Welcome = () => {
    const { setIsLoading } = useContext(LoadingContext);
    const history = useHistory();
    const { path: matchPath } = useRouteMatch();
    const stytchQueryString = useStytchQueryString();

    const [username, setUsername] = useState('');

    const [error] = useState(null);

    const onSubmit = async () => {
        setIsLoading(true);

        try {
            await requestPasswordReset(
                username,
                `${window.location.origin}${window.location.pathname}/authenticate${stytchQueryString}`
            );
            history.push(`${matchPath}/confirmation`);
        } catch (e) {
            console.log(e);
        }

        setIsLoading(false);
    };

    return (
        <>
            <h2 className="display5 text-center bold mb-4">Welcome ICSC Member!</h2>

            <p className="text-center mb-4 red-hat" style={{ fontSize: '1rem', lineHeight: 1.4, width: '95%' }}>
                To create an ICSC.com account, use the form below to receive an email with a link that will let you set
                a password. This link will expire in 2 hours.
            </p>

            <Formik initialValues={{ username }} onSubmit={onSubmit}>
                {() => (
                    <Form className="mb-4">
                        <TextInput
                            label="Email Address or Member ID#"
                            placeholder="Email Address or Member ID#"
                            name="username"
                            value={username}
                            onChange={e => {
                                setUsername(e.target.value);
                            }}
                            error={error}
                            required
                        />

                        <ButtonPrimaryLarge className="w-100 mt-1">Request a Set Password Email</ButtonPrimaryLarge>
                    </Form>
                )}
            </Formik>

            <p className="text-center mb-3 red-hat" style={{ fontSize: '1rem', lineHeight: 1.4, width: '95%' }}>
                Need help?
            </p>

            <p className="text-center mb-4 red-hat" style={{ fontSize: '1rem', lineHeight: 1.4, width: '95%' }}>
                <a className="accent" href="mailto:membership@icsc.com">
                    Contact us.
                </a>
            </p>
        </>
    );
};

export default Welcome;
